import { atom, computed, task, onMount, map } from 'nanostores'
import { persistentAtom } from '@nanostores/persistent'
import api from '@helpers/api'
import { fetchCustomer } from '@helpers/auth'
import { v4 as uuidv4 } from 'uuid'
import Cookies from 'js-cookie'

export const $selectedImageIndex = atom(false)

export const $isSearchOpen = atom(false)

export const $isSignupOpen = atom(false)

export const $ageVerificationSuccessful = atom(false)

export const $leadCaptureOpen = persistentAtom('lead_capture_open', '')

export const $exitIntentOpen = persistentAtom('exit_intent_open', '')

export const $isCartOpen = atom(false)

export const $isFirstLoad = persistentAtom('isFirstLoad', '')

export const $cartId = persistentAtom('cartId')

export const $cart = map({
    id: uuidv4(),
    items: [],
})

export const $customer = map({})

$cart.subscribe((cart) => {
    if (cart?.items?.length > 0 && !$cartId.get() && cart.id) {
        $cartId.set(cart.id)
    }
})

let hasFetched = false
$cartId.subscribe((id) => {
    if (!id || hasFetched) return
    hasFetched = true

    const controller = new AbortController()

    api.get(`/carts/${id}`, { signal: controller.signal })
        .then(({ data }) => {
            if (data?.data?.id) $cart.set(data.data)
        })
        .catch(err => {
            if (err.name !== 'AbortError') console.error('Failed to fetch cart:', err)
        })

    return () => controller.abort()
})

onMount($customer, () => {
    task(async () => {
        if (Cookies.get('customer_id')) {
            try {
                $customer.set(await fetchCustomer())
            } catch {}
        }
    })
})

export const $supportCode = computed($cartId, (cartId) => {
    return cartId?.substring(0, 8)?.toUpperCase()?.replace(/(.{4})/g, "$1-")?.replace(/.$/, "") || ''
})
export const $cartItemCount = computed($cart, (cart) => {
    return cart?.items?.reduce((acc, item) => acc + item.quantity, 0) || 0
})
